var React = require('react');
import MasterInput from './master'
class TextInput extends React.Component {

    render() {
        return (
            <MasterInput
                type=''
                actions={this.props.actions}
                store={this.props.store}
                fields={this.props.fields}
                name={this.props.name}
            />
        );
    }
}

export default TextInput
